/* import __COLOCATED_TEMPLATE__ from './customer.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { ShopifyCustomer } from '../shopify';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface Signature {
  Args: {
    shopifyCustomer: ShopifyCustomer;
    userShopifyDomain?: string;
    isExpanded?: boolean;
    toggleExpandCustomer?: () => void;
    setShowAllOrders?: () => void;
    shopifyCustomerOrdersUrl?: string;
    hasOrders?: boolean;
  };
}
export default class Inbox2Customer extends Component<Signature> {
  @service declare session: Session;
  // had to add this to support legacy behavior
  @tracked private internalIsExpanded = false;

  get isExpanded() {
    if (this.canUseShopifyMultiStore && this.args.isExpanded !== undefined) {
      return this.args.isExpanded;
    }
    return this.internalIsExpanded;
  }

  get shouldShowExpanded() {
    return this.isExpanded;
  }

  get canUseShopifyMultiStore() {
    return this.session.workspace.isFeatureEnabled('shopify-multi-store');
  }

  @action
  collapseOrExpand() {
    if (this.canUseShopifyMultiStore && this.args.toggleExpandCustomer) {
      this.args.toggleExpandCustomer();
    } else {
      this.internalIsExpanded = !this.internalIsExpanded;
    }
  }

  get userShopifyStoreName() {
    return this.args.userShopifyDomain?.split('.')[0] ?? '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::Customer': typeof Inbox2Customer;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/customer': typeof Inbox2Customer;
  }
}
